module.exports = "<p>\n  update-demo-markets works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-markets/update-demo-markets/update-demo-markets.component.html
// module id = ../../../../../src/app/components/pages/demo-company/demo-markets/update-demo-markets/update-demo-markets.component.html
// module chunks = main